import React from 'react'
import './topbar.scss'
import {Person, Mail, LinkedIn } from '@material-ui/icons';

export default function Topbar({ menuOpen, setMenuOpen}) {
    return (
        <div className={ 'topbar ' + (menuOpen && 'active') }>
            <div className='wrapper'>
                <div className='left'>
                    <a href="#intro" className='logo'>My Portfolio</a>
                    <div className='itemContainer'>
                        <Person />
                        <span>+61 414 002 947</span>
                    </div>
                    <div className='itemContainer'>
                        <Mail />
                        <span>rockyrai.9979@gmail.com</span>
                    </div>
                    <div className='itemContainer'>
                        <a href="https://www.linkedin.com/in/rocky-rai-85692b150/" target="_blank" rel="noreferrer"><LinkedIn /></a>
                        <span>@rocky-rai</span>
                    </div>
                </div>
                <div className='right'>
                    <div className="hamburger" onClick={ ()=> setMenuOpen(!menuOpen)}>
                        <span className='line1'></span>
                        <span className='line2'></span>
                        <span className='line3'></span>
                    </div>
                </div>
            </div>
        </div>


    )
}
